// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum CustomerPartialRefundCandidateRejectionReason {
  FuelTypeNotAllowed = "FUEL_TYPE_NOT_ALLOWED",
  WarningBypassingForbidden = "WARNING_BYPASSING_FORBIDDEN",
  UnreturnableRefund = "UNRETURNABLE_REFUND",
}
export default CustomerPartialRefundCandidateRejectionReason;
